export default __webpack_public_path__ + "static/media/Visa.5296530f.svg";